import { useState } from 'react';
import CallbackModal from '../components/CallbackModal';
import ProcessRoadmap from '../components/ProcessRoadmap';
import './Services.css';

import svc1 from '../assets/about/svc-1.jpg';
import svc2 from '../assets/about/svc-2.jpg';
import svc3 from '../assets/about/svc-3.jpg';
import svc4 from '../assets/about/svc-4.jpg';
import svc5 from '../assets/about/svc-5.jpg';
import svc6 from '../assets/about/svc-6.jpg';
import svc7 from '../assets/about/svc-7.jpg';
import svc8 from '../assets/about/svc-8.jpg';
import svc9 from '../assets/about/svc-9.jpg';

const valueServices = [
  {
    label: 'Value engineering',
    img: svc1,
    detail:
      'We review drawings, specs, and materials to find practical savings—better alternates, leaner details, and fewer variations—without cutting safety or finish quality.',
  },
  {
    label: 'Execution planning',
    img: svc2,
    detail:
      'Site readiness, method statements, and work sequences are planned so trades move in the right order, reducing idle time and rework on site.',
  },
  {
    label: 'Resource planning',
    img: svc3,
    detail:
      'Manpower peaks, plant, and key materials are aligned to the programme so critical activities are never waiting on people or deliveries.',
  },
  {
    label: 'Project management',
    img: svc4,
    detail:
      'Single-point coordination, site discipline, and clear reporting keep owners, consultants, and contractors aligned from foundation to handover.',
  },
  {
    label: 'Cost estimation',
    img: svc5,
    detail:
      'Transparent BOQ-style estimates and cash-flow views help you understand where money goes and compare options before you commit on site.',
  },
  {
    label: 'Conceptual scheduling',
    img: svc6,
    detail:
      'Early milestone maps and dependency checks highlight long-lead items—approvals, structure, MEP—so the calendar stays realistic from day one.',
  },
  {
    label: 'Architectural drawing',
    img: svc7,
    detail:
      'Clear plans, elevations, and details translate design intent into buildable sheets that contractors can price and execute with fewer RFIs.',
  },
  {
    label: 'Structural designing',
    img: svc8,
    detail:
      'Safe, code-aware RCC and steel solutions balance span, loads, and economy—documented for review and construction with clarity.',
  },
  {
    label: 'Government approvals',
    img: svc9,
    detail:
      'We support documentation and liaison for sanctions, NOCs, and compliance steps so statutory clearance does not become the critical delay.',
  },
];

const processSteps = [
  { n: '01', title: 'Raise a Request' },
  { n: '02', title: 'Meet our Experts' },
  { n: '03', title: 'Receive Drawings' },
  { n: '04', title: 'Project Planning' },
  { n: '05', title: 'Govt Approvals' },
  { n: '06', title: 'Agreements' },
  { n: '07', title: 'Get Updates' },
  { n: '08', title: 'Settle In' },
];

const heroQuickLinks = [
  { label: 'Residential', Icon: IconResidential },
  { label: 'Commercial', Icon: IconCommercial },
  { label: 'Turnkey', Icon: IconTurnkey },
  { label: 'Structural', Icon: IconStructural },
  { label: 'Approvals', Icon: IconApprovals },
];

function IconResidential({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M4 10.5L12 4l8 6.5V20a1 1 0 01-1 1h-5v-6H10v6H5a1 1 0 01-1-1v-9.5z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconCommercial({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M4 21V8l6-2v15M10 6l10 4v11M10 6V4h4v2M14 10h2M14 14h2M18 10h2M18 14h2"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconTurnkey({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M4 8h16v10a2 2 0 01-2 2H6a2 2 0 01-2-2V8zM8 8V6a4 4 0 018 0v2M12 12v4"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconStructural({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path d="M4 20h16M8 20V10l4-2v12M12 8l8 4v8" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconApprovals({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="22" height="22" fill="none" aria-hidden>
      <path
        d="M14 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V7l-5-5z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path d="M14 2v5h5M9 13l2 2 4-4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconBadgeShield({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden>
      <path
        d="M12 3L5 6v5c0 4.5 2.8 8.5 7 10 4.2-1.5 7-5.5 7-10V6l-7-3z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Services() {
  const [vasOpenKey, setVasOpenKey] = useState(null);
  const [callbackOpen, setCallbackOpen] = useState(false);

  const toggleVasCard = (key) => {
    // Only one card open at a time — others return to the photo side
    setVasOpenKey((prev) => (prev === key ? null : key));
  };

  return (
    <div className="services-page">
      <CallbackModal open={callbackOpen} onClose={() => setCallbackOpen(false)} />

      <header className="services-hero" aria-labelledby="services-hero-heading">
        <div className="services-hero-bg" aria-hidden="true" />
        <div className="services-hero-inner">
          <p className="services-hero-badge">
            <IconBadgeShield className="services-hero-badge-icon" />
            <span>Your trusted construction partner</span>
          </p>
          <h1 id="services-hero-heading" className="services-hero-title">
            <span className="services-hero-title-line">Complete construction</span>{' '}
            <span className="services-hero-title-accent">services under one roof</span>
          </h1>
          <p className="services-hero-lead">
            Design-through-delivery support for homes and workplaces in Delhi NCR—clear scope, disciplined
            site execution, and help with drawings, structure, and statutory approvals.
          </p>
          <button type="button" className="services-hero-cta" onClick={() => setCallbackOpen(true)}>
            Schedule free consultation
            <span className="services-hero-cta-arrow" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
                <path
                  d="M5 12h14M13 6l6 6-6 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </button>

          <ul className="services-hero-pills" aria-label="Service focus areas">
            {heroQuickLinks.map(({ label, Icon }) => (
              <li key={label} className="services-hero-pill">
                <span className="services-hero-pill-icon" aria-hidden="true">
                  <Icon />
                </span>
                <span className="services-hero-pill-label">{label}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="services-hero-wave" aria-hidden="true">
          <svg viewBox="0 0 1440 96" preserveAspectRatio="none" className="services-hero-wave-svg">
            <path d="M0,48 C240,12 480,84 720,48 C960,12 1200,84 1440,48 L1440,96 L0,96 Z" />
          </svg>
        </div>
      </header>

      <section className="services-vas-section">
        <div className="services-container">
          <h2 className="services-vas-title">Our Value Added Services</h2>
          <p className="services-vas-intro">
            Our plan is to grow Landmarks responsibly—serving more of Delhi NCR and eventually expanding
            across the region—so we can deliver the same ethical, detail-driven service at scale. We
            build relationships as solid as our structures.
          </p>
          <ul className="services-vas-grid">
            {valueServices.map(({ label, img, detail }) => {
              const flipped = vasOpenKey === label;
              return (
                <li key={label} className="services-vas-cell">
                  <div className="services-vas-card">
                    <button
                      type="button"
                      className={`services-vas-flip${flipped ? ' is-flipped' : ''}`}
                      onClick={() => toggleVasCard(label)}
                      aria-pressed={flipped}
                      aria-label={`${label}. ${flipped ? 'Show photo' : 'Flip for more about this service'}.`}
                    >
                      <span className="services-vas-flip-inner">
                        <span className="services-vas-face services-vas-face--front">
                          <img src={img} alt="" className="services-vas-img" />
                        </span>
                        <span className="services-vas-face services-vas-face--back">
                          <span className="services-vas-back-inner">
                            <span className="services-vas-back-title">{label}</span>
                            <span className="services-vas-back-detail">{detail}</span>
                          </span>
                        </span>
                      </span>
                    </button>
                    <p className="services-vas-label">{label}</p>
                    <p className="services-vas-hint">
                      {flipped ? 'Tap to show photo' : 'Tap for details'}
                    </p>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </section>

      <section className="services-process-section" id="work-process" aria-labelledby="services-process-heading">
        <div className="services-process-map-bg" aria-hidden="true" />
        <div className="services-container services-process-inner">
          <p className="services-process-kicker">Work process</p>
          <h2 id="services-process-heading" className="services-process-title">
            How Our Work Process
          </h2>
          <p className="services-process-sub">
            Follow the route from first enquiry to settling in—eight mapped steps, end to end.
          </p>
          <ProcessRoadmap steps={processSteps} />
        </div>
      </section>
    </div>
  );
}

